import { PurchaseListingPage } from "@/components/purchase-listing-page";
import { createFileRoute } from "@tanstack/react-router";
import { fallback, object, optional, string } from "valibot";

export const Route = createFileRoute("/_auth/_app/marketplace/purchase/$listingId/$variantId")({
  component: Component,
  validateSearch: object({
    offer: fallback(
      optional(
        object({
          id: string(),
          time: string(),
        }),
      ),
      undefined,
    ),
  }),
});

function Component() {
  const { listingId, variantId } = Route.useParams();
  const { offer } = Route.useSearch();

  return <PurchaseListingPage listingId={listingId} variantId={variantId} offer={offer} />;
}
